import { TeamRole } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

type TitleAndDescription = { title: string; description?: string };

export const roleNamesAndDescriptions: Record<TeamRole, TitleAndDescription> = {
  [TeamRole.Owner]: {
    title: translate('Team Owner'),
  },
  [TeamRole.Admin]: {
    title: translate('Team Admin'),
    description: translate('Can manage billing, team settings, and members'),
  },
  [TeamRole.Member]: {
    title: translate('Team Member'),
    description: translate('Can invite team members'),
  },
};
